import type { TreePickerItem, TreePickerItemWithValue } from './TreePickerItem';

export const mapCheckboxValuesToTree = <TKey extends string>(
  items: TreePickerItem<TKey>[],
  selected: Set<TKey>,
): TreePickerItemWithValue<TKey>[] =>
  items.map((item) => {
    if (item.children.length === 0) {
      return {
        ...item,
        children: [],
        value: selected.has(item.key),
      };
    }

    const itemWithValue: TreePickerItemWithValue<TKey> = {
      ...item,
      children: mapCheckboxValuesToTree(item.children, selected),
      value: false,
    };

    if (itemWithValue.children.every((child) => child.value === true)) {
      itemWithValue.value = true;
    } else if (itemWithValue.children.find((child) => child.value)) {
      itemWithValue.value = 'indeterminate';
    }

    return itemWithValue;
  });
